import request from '@/utils/request'

export function fetchLatestTask(query) {
  return request({
    url: '/v1/gpt-tasks/latest',
    method: 'get',
    params: query,
  })
}

export function fetchTaskDates(query) {
  return request({
    url: '/v1/gpt-tasks/dates',
    method: 'get',
    params: query,
  })
}

export function fetchOneTask(id) {
  return request({
    url: '/v1/gpt-tasks/' + id,
    method: 'get',
  })
}

export function fetchTasks(query) {
  return request({
    url: '/v1/gpt-tasks',
    method: 'get',
    params: query,
  })
}

export function createTask(data) {
  return request({
    url: '/v1/gpt-tasks',
    method: 'post',
    data
  })
}

export function restartTask(id) {
  return request({
    url: '/v1/gpt-tasks/' + id + '/restart',
    method: 'post',
  })
}

export function abortTask(id) {
  return request({
    url: '/v1/gpt-tasks/' + id + '/abort',
    method: 'post',
  })
}

export function deleteTask(id) {
  return request({
    url: '/v1/gpt-tasks/' + id,
    method: 'delete',
  })
}

export function fetchImages(query) {
  return request({
    url: '/v1/gpt-images',
    method: 'get',
    params: query
  })
}

export function blockImage(id) {
  return request({
    url: '/v1/gpt-images/block/' + id,
    method: 'post',
  })
}

export function addFavoriteImage(id) {
  return request({
    url: '/v1/gpt-images/favorite/' + id,
    method: 'post',
  })
}

export function delFavoriteImage(id) {
  return request({
    url: '/v1/gpt-images/favorite/' + id,
    method: 'delete',
  })
}

export function fetchOptions(query) {
  return request({
    url: '/v1/gpt-tasks/options',
    method: 'get',
    params: query
  })
}

export function fetchOptionDisables() {
  return request({
    url: '/v1/gpt-tasks/options/disabled',
    method: 'get'
  })
}

export function fetchTargets(query) {
  return request({
    url: '/v1/gpt-targets',
    method: 'get',
    params: query
  })
}

export function qaChat(data, cancelToken) {
  return request({
    url: '/v1/gpt-chat',
    method: 'post',
    data,
    cancelToken
  })
}

export function fetchQaChatSessionList(query) {
  return request({
    url: '/v1/gpt-chat/session',
    method: 'get',
    params: query
  })
}

export function fetchQaChatSessionDetail(id) {
  return request({
    url: '/v1/gpt-chat/session/' + id,
    method: 'get',
  })
}

export function updateQaChatSession(id, data) {
  return request({
    url: '/v1/gpt-chat/session/' + id,
    method: 'patch',
    data
  })
}

export function deleteQaChatSession(id) {
  return request({
    url: '/v1/gpt-chat/session/' + id,
    method: 'delete',
  })
}

export function execGenerate(id) {
  return request({
    url: '/v1/gpt-images/regenerate/' + id,
    method: 'post',
  })
}

export function queryGenerate(id) {
  return request({
    url: '/v1/gpt-images/regenerate/' + id,
    method: 'get',
  })
}